import client from './client';

export const vulnerabilitiesApi = {
  async listWatches() {
    const { data } = await client.get('/api/vulnerabilities/watches');
    return data;
  },

  async getWatch(id) {
    const { data } = await client.get(`/api/vulnerabilities/watches/${id}`);
    return data;
  },

  async validate(params) {
    const { data } = await client.post('/api/vulnerabilities/validate', params);
    return data;
  },

  async createWatch(watch) {
    const { data } = await client.post('/api/vulnerabilities/watches', watch);
    return data;
  },

  async updateWatch(id, updates) {
    const { data } = await client.patch(`/api/vulnerabilities/watches/${id}`, updates);
    return data;
  },

  async deleteWatch(id) {
    const { data } = await client.delete(`/api/vulnerabilities/watches/${id}`);
    return data;
  },

  async checkWatch(id) {
    const { data } = await client.post(`/api/vulnerabilities/watches/${id}/check`);
    return data;
  },

  async acknowledge(id, payload) {
    const { data } = await client.post(`/api/vulnerabilities/watches/${id}/acknowledge`, payload);
    return data;
  },

  async unacknowledge(id, payload) {
    const { data } = await client.post(`/api/vulnerabilities/watches/${id}/unacknowledge`, payload);
    return data;
  },

  async checkAll() {
    const { data } = await client.post('/api/vulnerabilities/check-all');
    return data;
  },
};
